export const IMAGE_TYPES: string[] = ['.jpg', '.jpeg', '.png', '.webp'];
export const AI_TYPES: string[] = ['.csv', '.tsv', '.txt', '.md', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
